import React, { FC } from 'react'
import { SellerProfile } from '../components/SellerProfile'
import UserProfile from '../components/UserProfile'

interface IProfilePageType {
    user: React.ReactElement
    seller: React.ReactElement
}

const ProfilePageType: IProfilePageType = {
    user: <UserProfile />,
    seller: <SellerProfile />,
}

type ProfilePage = 'user' | 'seller'

interface ProfileType {
    profile: ProfilePage
}

const ProfileProxy: FC<ProfileType> = ({ profile }) => {
    const Profile = ProfilePageType[profile]

    return Profile
}

export { ProfileProxy }
